var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-layout",
    { staticClass: "card" },
    [
      _c(
        "md-dialog",
        { ref: _vm.dialogRef, attrs: { "md-click-outside-to-close": false } },
        [
          _c("md-dialog-title", [_vm._v("Preferences")]),
          _c("pre", { staticClass: "dialog-content" }, [
            _vm._v(_vm._s(_vm.dialogContent))
          ]),
          _c(
            "md-dialog-actions",
            [
              _c(
                "md-button",
                {
                  staticClass:
                    "md-button md-raised md-primary handPointer md-theme-blue",
                  on: {
                    click: function($event) {
                      return _vm.closeDialog()
                    }
                  }
                },
                [_vm._v("Close")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "md-table-card",
        { staticClass: "table-card" },
        [
          _c(
            "form",
            {
              staticClass: "search-form",
              attrs: { novalidate: "novalidate" },
              on: {
                submit: function($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.resetPaginationAndSearch.apply(null, arguments)
                }
              }
            },
            [
              _c(
                "md-layout",
                { attrs: { "md-gutter": 24, "md-flex": "100" } },
                [
                  _c(
                    "md-layout",
                    { attrs: { "md-flex": "30" } },
                    [
                      _c(
                        "md-input-container",
                        [
                          _c("label", [_vm._v("User Name or ID")]),
                          _c("md-input", {
                            model: {
                              value: _vm.filters.target,
                              callback: function($$v) {
                                _vm.$set(_vm.filters, "target", $$v)
                              },
                              expression: "filters.target"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "md-layout",
                    { attrs: { "md-flex": "20" } },
                    [
                      _c("date-input", {
                        attrs: {
                          validation: _vm.$v.filters.startDate,
                          formSubmitted: true,
                          label: "From date"
                        },
                        model: {
                          value: _vm.filters.startDate,
                          callback: function($$v) {
                            _vm.$set(_vm.filters, "startDate", $$v)
                          },
                          expression: "filters.startDate"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "md-layout",
                    { attrs: { "md-flex": "20" } },
                    [
                      _c("date-input", {
                        attrs: {
                          validation: _vm.$v.filters.endDate,
                          formSubmitted: true,
                          label: "To date"
                        },
                        model: {
                          value: _vm.filters.endDate,
                          callback: function($$v) {
                            _vm.$set(_vm.filters, "endDate", $$v)
                          },
                          expression: "filters.endDate"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "md-layout",
                    [
                      _vm.filters.target ||
                      _vm.filters.startDate ||
                      _vm.filters.endDate != ""
                        ? _c(
                            "md-layout",
                            { attrs: { "md-flex": "20" } },
                            [
                              _c(
                                "md-button",
                                {
                                  staticClass:
                                    "clean-search-label-btn md-icon-button btn",
                                  on: { click: _vm.cleanFilters }
                                },
                                [
                                  _c("md-icon", {
                                    staticClass: "icon",
                                    attrs: { "md-iconset": "fa fa-trash-alt" }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "md-layout",
                        {
                          attrs: { "md-flex": "25", "md-align-small": "center" }
                        },
                        [
                          _c(
                            "md-button",
                            {
                              staticClass:
                                "search-btn md-raised md-icon-button btn",
                              attrs: {
                                type: "submit",
                                disabled: _vm.loading || _vm.$v.$invalid
                              }
                            },
                            [
                              _c("md-icon", {
                                staticClass: "icon",
                                attrs: { "md-iconset": "fa fa-search" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm.loading
            ? _c("stitch-loader", { attrs: { loading: _vm.loading, size: 45 } })
            : _vm._e(),
          _vm.hasLogsToDisplay
            ? _c(
                "div",
                [
                  _c("div", { staticClass: "titleLine styleRow" }, [
                    _c("p", { staticClass: "rowElements" }, [_vm._v("Email")]),
                    _c("p", { staticClass: "rowElements" }, [
                      _vm._v("Entity Name")
                    ]),
                    _c("p", { staticClass: "rowElements" }, [_vm._v("Action")]),
                    _c("p", { staticClass: "rowElements" }, [
                      _vm._v("Action performed at")
                    ]),
                    _c("p", { staticClass: "rowElements" })
                  ]),
                  _vm._l(_vm.logs, function(log) {
                    return _c(
                      "div",
                      { key: log._id, staticClass: "styleRow colorHover" },
                      [
                        _c("div", { staticClass: "rowElements" }, [
                          _vm._v(_vm._s(log.userEmail))
                        ]),
                        _c("div", { staticClass: "rowElements" }, [
                          _vm._v(_vm._s(log.actionValue.name))
                        ]),
                        _c("div", { staticClass: "rowElements" }, [
                          _vm._v(_vm._s(log.action))
                        ]),
                        _c("div", { staticClass: "rowElements" }, [
                          _vm._v(_vm._s(_vm.moment(log.dateCreated)))
                        ]),
                        _c(
                          "div",
                          { staticClass: "rowElements" },
                          [
                            _c(
                              "md-button",
                              {
                                staticClass: "md-icon-button md-raised btn",
                                on: {
                                  click: function($event) {
                                    return _vm.viewDetail(log.actionValue)
                                  }
                                }
                              },
                              [
                                _c("md-icon", {
                                  staticClass: "icon",
                                  attrs: { "md-iconset": "fa fa fa-eye" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    )
                  })
                ],
                2
              )
            : _vm._e(),
          _c("md-table-pagination", {
            attrs: {
              "md-size": _vm.currentPagination.size,
              "md-total": _vm.totalLogs,
              "md-page": _vm.currentPagination.page,
              "md-label": "Logs",
              "md-separator": "of",
              "md-page-options": [10, 25, 50, 100]
            },
            on: { pagination: _vm.onPageChanged }
          }),
          _vm.hasNoResults
            ? _c(
                "div",
                { attrs: { id: "no-results" } },
                [
                  _c("md-icon", {
                    staticClass: "md-accent",
                    attrs: { "md-iconset": "fa fa-exclamation-circle" }
                  }),
                  _vm._v("No items to show")
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c5ed2b4", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c5ed2b4","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/userActivity/activityTable.vue
// module id = 1044
// module chunks = 0